module.exports = __webpack_public_path__ + "static/media/md-bulb.e9e755f4.svg";